import React, { useRef } from "react"
import { Heading, Text, Button, Box, AspectRatio, Stack } from "@chakra-ui/react"

import { useRoutes } from "@hooks/useRoutes"
import { useImage } from "@hooks/useImage"
import Link from "@components/Link"
import Image from "@components/Image/Image"
import Illustration from "@components/Illustration"
import { CallToActionProps } from "./CallToAction"

const CallToActionMobile = ({
  title,
  content,
  image: rawImage,
  link: rawLink,
  handleTrackingClick,
}: Omit<CallToActionProps, "innerRef">) => {
  const { getResponsiveImage } = useImage()
  const { urlResolver } = useRoutes()

  const imageRef = useRef<HTMLImageElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)

  const image = getResponsiveImage(rawImage)
  const link = urlResolver(rawLink)

  const callToAction = React.useCallback(
    (absolute = false) => {
      return (
        <>
          <Box
            ref={contentRef}
            pos={absolute && "absolute"}
            // marginTop={!absolute && "-30%"}
            opacity={!absolute && 0}
            pointerEvents={!absolute && "none"}
            bg="brand.beige.dark"
            borderRadius="sm"
            py={3.5}
            px={3.5}
            w="90%"
            left="50%"
            transform="translate(-50%, -30%)"
            textAlign="center"
          >
            <Stack spacing={2} justifyContent="center" alignItems="center">
              {title && (
                <Heading as="h2" size="xl">
                  {title}
                </Heading>
              )}
              {content && <Text>{content}</Text>}
              {link && (
                <Button as={Link} to={link.url} variant="blue" onClick={handleTrackingClick}>
                  {link.title}
                </Button>
              )}
            </Stack>
          </Box>
        </>
      )
    },
    [title, content, link, handleTrackingClick]
  )

  return (
    <Box pos="relative">
      {image && (
        <Box ref={imageRef}>
          <AspectRatio ratio={75 / 86} w="full">
            <Image {...image} objectFit="cover" />
          </AspectRatio>
        </Box>
      )}
      {callToAction(true)}
      {callToAction()}
      <Illustration name="dandelion" pos="absolute" left="-45px" bottom="230px" transform="rotate(45deg)" />
    </Box>
  )
}

export default React.memo(CallToActionMobile)
